import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Link, } from 'react-router-dom';
import { AntdButton, InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import PointOfContact from "./poinOfContact.js";
import Slots from "./slots.js";
import { addClient, setClientProfile } from '../../../Slices/clientSlice.jsx';
import DateComponent from "./partnerShipDetails.js";
import { getOptionsByPath } from '../../../utilsdata.js';
import { ADD_CLIENT_DEPARTMENT, ADD_CLIENT_TIMEZONE, CLIENT_SERVICESASSIGNED, CLIENT_STATUS, CLIENT_INFO, ADD_CLIENT } from '../../../Dropdownmanager.jsx';
import { GetClientById } from '../../../Slices/Thunk/Reports.jsx';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { updateClient } from '../../../Slices/clientSlice.jsx';
import { UPDATE_CLIENT, EDIT_CLIENT, CREATE_CLIENT } from '../../../Queries/Orders.js';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd'
import { setLoader } from '../../../Slices/loaderSlice.jsx';
import { SERVER_URL } from '../../../databucket.js';
import { EmployeeMapIng } from './EmployeeClientMap.js';
import { EditClientHistory } from './ClientEditHistory.jsx';
import { useSelector } from "react-redux";
import { validateFields } from './validation.js';
import axios from 'axios';
import { S3ACCESSURL } from '../../../databucket.js';
import { useRecordLock } from "../../../hooks/useRecordLock";
import RecordLockedModal, { ReleaseRequestBanner } from "../../../components/RecordLockedModal";
import WhatsAppRecordTab, { useCanSeeWhatsApp } from "../WhatsApp/WhatsAppRecordTab";

// ============================================================================
// CLIENT PROFILE — "SIDEBAR PROFILE" REDESIGN (scoped under `.bpcp`)
// A full-height left identity rail (avatar + upload, name, status, key stats,
// vertical section nav) and a clean right panel (top bar + form). Everything is
// nested under `.bpcp` so it only affects this page and the Contacts/Slots
// sub-components that render inside it — never the global theme. No JSX logic,
// field bindings, save/validation or lock behaviour is changed; only the
// presentational markup wrappers and CSS.
// ============================================================================
const BPCP_STYLES = `
.bpcp {
  --ink:#0f172a; --muted:#64748b; --line:#e7ebf2; --accent:#4f46e5;
  --accent2:#0ea5e9; --soft:#f8fafc; --rail:#0f1729;
}

/* ---- Shell: rail | main ---- */
.bpcp .bpcp-shell {
  display:grid; grid-template-columns:288px 1fr; gap:20px;
  align-items:start; margin-top:4px;
}
@media (max-width:1100px){ .bpcp .bpcp-shell { grid-template-columns:1fr; } }

/* ===================== LEFT IDENTITY RAIL ===================== */
.bpcp .bpcp-rail {
  position:sticky; top:8px;
  background:linear-gradient(180deg,#0f1729 0%,#172139 100%);
  border:1px solid #1e293b; border-radius:20px; padding:26px 20px 18px;
  box-shadow:0 24px 48px -24px rgba(15,23,41,.55);
  display:flex; flex-direction:column; align-items:center;
  color:#e2e8f0;
}
.bpcp .bpcp-rail-avatar { position:relative; display:flex; align-items:center; justify-content:center; }
/* avatar: de-hack any -100px pull from inline styles, render a tidy rounded square */
.bpcp .bpcp-rail-avatar .w-120 { margin:0 !important; }
.bpcp .bpcp-rail-avatar .w-120 > div { margin:0 !important; }
.bpcp .bpcp-rail-avatar .w-120 > div > div,
.bpcp .bpcp-rail-avatar .w-120 .profile-img,
.bpcp .bpcp-rail-avatar .w-120 img {
  width:96px !important; height:96px !important; min-width:96px !important;
  border-radius:26px !important; font-size:30px !important; font-weight:700 !important;
  border:3px solid rgba(255,255,255,.14) !important;
  box-shadow:0 16px 32px -12px rgba(0,0,0,.6), 0 0 0 1px rgba(255,255,255,.04) inset !important;
  background:linear-gradient(135deg,#6366f1,#0ea5e9) !important; color:#fff !important;
  overflow:hidden; letter-spacing:.5px;
}
.bpcp .bpcp-rail-avatar .plus-icon,
.bpcp .bpcp-rail-avatar .edit-icon,
.bpcp .bpcp-rail-avatar .action-icons a { color:#fff !important; }

.bpcp .bpcp-rail-name { margin-top:16px; font-size:17px; font-weight:750; letter-spacing:-.02em; color:#f8fafc; text-align:center; line-height:1.25; word-break:break-word; }
.bpcp .bpcp-rail-status { margin-top:8px; font-size:11px; font-weight:700; padding:4px 13px; border-radius:999px; display:inline-flex; align-items:center; gap:6px; }
.bpcp .bpcp-rail-status::before { content:""; width:6px; height:6px; border-radius:50%; background:currentColor; }
.bpcp .bpcp-rail-status.on { color:#34d399; background:rgba(16,185,129,.14); }
.bpcp .bpcp-rail-status.off { color:#f87171; background:rgba(239,68,68,.14); }

/* stat tiles */
.bpcp .bpcp-rail-stats { width:100%; margin-top:20px; display:flex; flex-direction:column; gap:9px; }
.bpcp .bpcp-rail-stat { display:flex; align-items:center; gap:11px; padding:11px 13px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.07); border-radius:13px; }
.bpcp .bpcp-rail-stat-ico { width:32px; height:32px; flex:none; border-radius:9px; display:flex; align-items:center; justify-content:center; font-size:14px; color:#fff; background:linear-gradient(135deg,#6366f1,#0ea5e9); }
.bpcp .bpcp-rail-stat-txt { min-width:0; display:flex; flex-direction:column; }
.bpcp .bpcp-rail-stat-txt span { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:.06em; color:#7c8aa5; }
.bpcp .bpcp-rail-stat-txt b { font-size:13px; font-weight:600; color:#e2e8f0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }

/* vertical section nav */
.bpcp .bpcp-rail-nav { width:100%; margin-top:20px; padding-top:16px; border-top:1px solid rgba(255,255,255,.08); display:flex; flex-direction:column; gap:4px; }
.bpcp .bpcp-rail-tab { display:flex; align-items:center; gap:11px; width:100%; text-align:left; border:0; background:transparent; color:#94a3b8; font-weight:600; font-size:13.5px; padding:10px 13px; border-radius:11px; cursor:pointer; transition:all .15s ease; }
.bpcp .bpcp-rail-tab:hover { background:rgba(255,255,255,.05); color:#e2e8f0; }
.bpcp .bpcp-rail-tab.active { background:linear-gradient(135deg,#4f46e5,#0ea5e9); color:#fff; box-shadow:0 8px 18px -8px rgba(79,70,229,.7); }
.bpcp .bpcp-rail-tab-ico { width:20px; text-align:center; font-size:14px; }

/* ===================== RIGHT MAIN PANEL ===================== */
.bpcp .bpcp-main { min-width:0; display:flex; flex-direction:column; gap:16px; }
.bpcp .bpcp-topbar { display:flex; align-items:center; gap:14px; }
.bpcp .bpcp2-back { display:inline-flex; align-items:center; gap:6px; border:1px solid var(--line); background:#fff; color:#475569; font-weight:600; font-size:13px; padding:9px 15px; border-radius:11px; cursor:pointer; transition:all .15s ease; }
.bpcp .bpcp2-back:hover { background:#f3f6fb; color:var(--ink); border-color:#cdd6e4; }
.bpcp .bpcp2-back-ico { font-size:19px; line-height:1; margin-top:-2px; }
.bpcp .bpcp-topbar-title { flex:1; display:flex; flex-direction:column; gap:2px; min-width:0; }
.bpcp .bpcp-topbar-title .t1 { font-size:19px; font-weight:780; letter-spacing:-.02em; color:var(--ink); line-height:1.15; }
.bpcp .bpcp-topbar-title .t2 { font-size:12px; font-weight:600; color:var(--muted); }
.bpcp .bpcp2-save { border:0; background:linear-gradient(135deg,#4f46e5,#0ea5e9); color:#fff; font-weight:650; font-size:13.5px; padding:11px 24px; border-radius:11px; cursor:pointer; box-shadow:0 12px 22px -8px rgba(79,70,229,.55); transition:all .15s ease; }
.bpcp .bpcp2-save:hover { filter:brightness(1.05); transform:translateY(-1px); }

/* panel card */
.bpcp .bpcp-panel { background:#fff; border:1px solid var(--line); border-radius:18px; box-shadow:0 1px 2px rgba(16,24,40,.05); padding:24px 26px; }
.bpcp .bpcp-panel-head { display:flex; align-items:center; gap:9px; margin:0 0 20px; }
.bpcp .bpcp-panel-head .bar { width:4px; height:18px; border-radius:3px; background:linear-gradient(180deg,#4f46e5,#0ea5e9); }
.bpcp .bpcp-panel-head .ttl { font-size:15px; font-weight:750; letter-spacing:-.01em; color:var(--ink); }

/* field grid: turn bootstrap row/cols into a responsive grid */
.bpcp .bpcp-grid .row { display:grid !important; grid-template-columns:repeat(auto-fit, minmax(200px, 1fr)) !important; gap:16px 18px !important; margin:0 !important; width:100% !important; }
.bpcp .bpcp-grid [class*="col-md-"],
.bpcp .bpcp-grid [class*="col-sm-"],
.bpcp .bpcp-grid [class*="col-lg-"] { max-width:none !important; flex:initial !important; width:auto !important; padding:0 !important; margin:0 !important; }
.bpcp .bpcp-grid .input-block { margin-bottom:0 !important; }

/* ----- Cards (Contacts / Slots sub-components) ----- */
.bpcp .card { background:#fff; border:1px solid var(--line) !important; border-radius:16px !important; box-shadow:0 1px 2px rgba(16,24,40,.04) !important; }
.bpcp .card.tab-box { padding:20px 22px !important; }
.bpcp .card .card.mb-0 { border-radius:13px !important; background:var(--soft); box-shadow:none !important; margin-bottom:12px !important; }
.bpcp .card-body { padding:14px 16px !important; }

/* Section titles (Slots / Point of Contact) */
.bpcp h3.mx-auto { text-align:left; font-size:15px !important; font-weight:750; letter-spacing:-.01em; color:var(--ink); margin:0 0 16px !important; }
.bpcp .card-title { font-size:13.5px !important; font-weight:700; color:var(--ink); display:inline-flex; align-items:center; gap:8px; }
.bpcp .card-title::before { content:""; width:4px; height:14px; border-radius:3px; background:var(--accent); }

/* ----- Inputs / selects (page-wide, incl. Contacts & Slots) ----- */
.bpcp .col-form-label { font-size:10px !important; font-weight:700 !important; text-transform:uppercase; letter-spacing:.05em; color:#94a3b5 !important; margin-bottom:6px !important; padding:0 !important; }
.bpcp .ant-input, .bpcp .form-control,
.bpcp input:not([type=file]):not(.ant-select-selection-search-input) {
  height:38px !important; min-height:38px !important; font-size:13px !important; padding:5px 12px !important;
  border-radius:10px !important; color:var(--ink);
  background:#f1f5f9 !important; border:1.5px solid transparent !important; box-shadow:none !important;
  transition:background .15s ease, border-color .15s ease, box-shadow .15s ease;
}
.bpcp textarea.ant-input, .bpcp textarea.form-control { height:auto !important; min-height:62px !important; padding:8px 12px !important; }
.bpcp .ant-input:hover, .bpcp .form-control:hover { background:#e8eef6 !important; }
.bpcp .ant-input:focus, .bpcp .form-control:focus, .bpcp .ant-input-focused {
  background:#fff !important; border-color:var(--accent) !important; box-shadow:0 0 0 3px rgba(79,70,229,.13) !important;
}
.bpcp .ant-select .ant-select-selector {
  min-height:38px !important; border-radius:10px !important; align-items:center;
  background:#f1f5f9 !important; border:1.5px solid transparent !important; box-shadow:none !important;
}
.bpcp .ant-select-single .ant-select-selector { height:38px !important; }
.bpcp .ant-select:hover .ant-select-selector { background:#e8eef6 !important; }
.bpcp .ant-select-focused .ant-select-selector { background:#fff !important; border-color:var(--accent) !important; box-shadow:0 0 0 3px rgba(79,70,229,.13) !important; }
.bpcp .ant-select-selection-item, .bpcp .ant-select-selection-placeholder { line-height:34px !important; font-size:13px !important; }

.bpcp .input-block { margin-bottom:14px !important; }
`;

export const ClientProfiles = () => {


    const Employee = useSelector((state) => state?.employee?.AllEmployees);
    const dispatch = useDispatch();
    const { id } = useParams()
    const navigation = useNavigate()
    const [image, setImage] = useState(null);
    const [updateclient] = useMutation(UPDATE_CLIENT);
    const [addClientMutation] = useMutation(CREATE_CLIENT);
    const [editClient,] = useMutation(EDIT_CLIENT);
    const [pointofCon, setpointCon] = useState([]);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const [slo, setSlot] = useState([]);
    const [partners, setPartners] = useState({});
    const [agence, setAgency] = useState({})
    const [mainobj, setobj] = useState({})
    const [activeTab, setActiveTab] = useState("Employee_List");
    const [section, setSection] = useState("details"); // top-level section tabs
    const canSeeWhatsApp = useCanSeeWhatsApp();
    const [errors, setErrors] = useState({
        pointOfContact: [],       // Array of objects (one per contact)
    });
    const [agencyData, setAgencyData] = useState({});
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

    // Session lock — only lock when editing an existing client (id present)
    const {
        isReadOnly: lockIsReadOnly,
        lockedBy,
        lockChecked,
        requestAccess,
        releaseRequested,
        releaseRequestFrom,
        dismissReleaseRequest,
        releaseForRequester,
    } = useRecordLock("clients", id || null);

    const [viewReadOnly, setViewReadOnly] = useState(false);
    const isReadOnly = id ? (lockIsReadOnly && viewReadOnly) : false;

    const clientConfidentialAccess = useMemo(() =>
        loginUser?.client
            ?.find(client => client.NameOfClient === agencyData?.clientName)
            ?.confidentialAcess || false,
        [loginUser, agencyData?.clientName]  // ✅ only recalculates when these change
    );

    const Employees = useMemo(() =>
        Employee
            ?.filter((emp) => emp.employeestatus === "Active")
            .map((item, index) => ({
                key: index,
                label: `${item.firstname} ${item.lastname}`,
                value: `${item.firstname} ${item.lastname}`,
            })) || [],
        [Employee]
    );
    const requiredFields = [
        { key: 'clientName', message: 'Agency Name is required' },
        { key: 'physicalAddress', message: 'Address is required' },
        { key: 'city', message: 'City is required' },
        { key: 'state', message: 'State is required' },
        { key: 'zip', message: 'Zip is required' },
        { key: 'timeZone', message: 'Time Zone is required' },
        { key: 'noOfSlots', message: 'No. of Slots is required' },
        { key: 'department', message: 'Department is required' },
        { key: 'ServicesAssigned', message: 'Service is required' },
        { key: 'BlueplanitReportingLead', message: 'Lead is required' },
        { key: 'status', message: 'status is required' }
    ];
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAgencyData((prev) => ({ ...prev, [name]: value }));
    };
    const HandleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validateFields(agencyData, requiredFields);;

        setErrors(newErrors);

        try {
            if (Object.keys(newErrors).length === 0) {
                dispatch(setLoader(true))
                const {
                    EditClient,
                    __typename,
                    slots,
                    PointofContact,
                    PartnershipDetails,
                    // Invoice arrays are owned by the invoice flow, not this
                    // profile form. Excluding them (a) stops Apollo's nested
                    // __typename from being echoed back — which clientInputType
                    // rejects and silently fails the whole save — and (b) avoids
                    // partially overwriting stored invoice data on a profile edit.
                    InvoiceDetails,
                    GeneratedInvoices,
                    ...rest
                } = agencyData;

                // Recursively strip any remaining __typename (defensive — covers
                // every nested object/array, including ones added in future).
                const stripTypename = (val) => {
                    if (Array.isArray(val)) return val.map(stripTypename);
                    if (val && typeof val === "object") {
                        const { __typename: _t, ...obj } = val;
                        return Object.fromEntries(
                            Object.entries(obj).map(([k, v]) => [k, stripTypename(v)])
                        );
                    }
                    return val;
                };

                // Clean nested arrays and objects
                const cleanedSlots = slots?.map(({ __typename, ...item }) => item) || [];
                const cleanedPointOfContact = PointofContact?.map(({ __typename, ...item }) => item) || [];
                const { __typename: partnershipTypeName, ...PartnershipDetailsNew } = PartnershipDetails || {};

                // Construct cleaned input
                let agencyDataNew = stripTypename({
                    ...rest,
                    slots: cleanedSlots,
                    PointofContact: cleanedPointOfContact,
                    PartnershipDetails: PartnershipDetailsNew,
                });
                if (id) {
                    if (JSON.stringify(agence) !== JSON.stringify(agencyData)) {
                        dispatch(setClientProfile(agencyData));
                        const { data } = await updateclient({
                            variables: {
                                input: agencyDataNew,
                            },
                        });
                        if (data?.updateclient?.status === "200") {
                            dispatch(updateClient(agencyDataNew))
                            const EditClient = {
                                id: `${loginUser.firstname} ${loginUser.lastname}`,
                                clientId: agencyDataNew?.id,
                                userName: agencyDataNew.clientName,
                                EditStatus: agencyDataNew?.status,
                                changeTime: new Date().toISOString()
                            }
                            const obj = {
                                clientName: agencyDataNew?.clientName,
                                physicalAddress: agencyDataNew?.physicalAddress,
                                city: agencyDataNew?.city,
                                state: agencyDataNew?.state,
                                zip: agencyDataNew?.zip,
                                timeZone: agencyDataNew?.timeZone,
                                noOfSlots: agencyDataNew?.noOfSlots,
                                department: agencyDataNew?.department,
                                ServicesAssigned: agencyDataNew?.ServicesAssigned,
                                BlueplanitReportingLead: agencyDataNew?.BlueplanitReportingLead,
                                status: agencyDataNew?.status
                            }
                            if (JSON.stringify(mainobj) !== JSON.stringify(obj)) {

                                await editClient({
                                    variables: {
                                        input: { ...EditClient, action: "Agency Info" }
                                    }
                                }
                                )
                            }
                            if (JSON.stringify(pointofCon) !== JSON.stringify(PointofContact)) {

                                await editClient({
                                    variables: {
                                        input: { ...EditClient, action: "PointOfContact" }
                                    }
                                }
                                )
                            }
                            if (JSON.stringify(slo) !== JSON.stringify(slots)) {
                                await editClient({
                                    variables: {
                                        input: { ...EditClient, action: "Slots" }
                                    }
                                }
                                )
                            }
                            if (JSON.stringify(partners) !== JSON.stringify(PartnershipDetails)) {

                                await editClient({
                                    variables: {
                                        input: { ...EditClient, action: "PartnerShipDetails" }
                                    }
                                }
                                )
                            }
                            setSlot(slots)
                            setpointCon(PointofContact);
                            setPartners(PartnershipDetails)
                            setAgency(agencyData)
                            setobj(obj)
                            message.success({
                                content: "Updated successfully",
                                duration: 2,
                            });
                        } else {
                            message.error({
                                content: data?.updateclient?.message || "Couldn't update the client.",
                                duration: 4,
                            });
                        }
                    } else {
                        message.info({
                            content: "No change Is detacted",
                            duration: 2,
                        });

                    }

                } else {
                    const { data } = await addClientMutation({
                        variables: {
                            input: agencyDataNew,
                        },
                    });

                    if (data?.createclient?.status === "200") {
                        setAgencyData({})
                        dispatch(addClient({ ...agencyDataNew, id: data?.createclient?.id }))
                        message.success({
                            content: "Added successfully",
                            duration: 2,
                        });
                    } else {
                        dispatch(setLoader(false))
                        message.error({
                            content: data?.createclient?.message,
                            duration: 5
                        })
                    }
                }

            }
        }
        catch (e) {
            console.error("Client update failed:", e);
            message.error({
                content: e?.message || "Couldn't save the client. Please try again.",
                duration: 4,
            });
        } finally {
            dispatch(setLoader(false))
        }
    };
    const getInitials = (name) => {
        const initials = name.split(' ').map((word) => word.charAt(0).toUpperCase()).join('');
        return initials;
    };

    useEffect(() => {
        (async () => {
            try {
                if (id) {
                    dispatch(setLoader(true))
                    const response = await dispatch(GetClientById(id));
                    const recordsWithTime = response?.payload;
                    const mainData = recordsWithTime?.[0] || {};
                    const {
                        slots,
                        PointofContact,
                        PartnershipDetails
                    } = mainData;
                    setAgencyData(mainData);
                    setSlot(slots)
                    setpointCon(PointofContact);
                    setPartners(PartnershipDetails)
                    setAgency(mainData)
                    setobj({
                        clientName: agencyData?.clientName,
                        physicalAddress: agencyData?.physicalAddress,
                        city: agencyData?.city,
                        state: agencyData?.state,
                        zip: agencyData?.zip,
                        timeZone: agencyData?.timeZone,
                        noOfSlots: agencyData?.noOfSlots,
                        department: agencyData?.department,
                        ServicesAssigned: agencyData?.ServicesAssigned,
                        BlueplanitReportingLead: agencyData?.BlueplanitReportingLead,
                        status: agencyData?.status
                    })
                    setImage(mainData?.image)

                    dispatch(setClientProfile(mainData));
                    dispatch(setLoader(false))
                }
            } catch (e) {
                console.error("Error fetching client details:", e);
                dispatch(setLoader(false))
            }
        })();
    }, [id]);

    const handleImageChange = async (e) => {
        const file = e.target.files[0];

        if (file) {
            dispatch(setLoader(true));

            const formData = new FormData();
            formData.append('files', file);
            try {
                const res = await axios.post(`${SERVER_URL}/upload`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                const savedFile = res.data.files[0];
                const { data } = await updateclient({
                    variables: {
                        input: {
                            id: id,
                            image: savedFile.url
                        }
                    },
                });
                if (data?.updateclient?.status === "200") {
                    const updatedClient = {
                        ...agencyData,
                        image: savedFile.url
                    };
                    message.success({
                        content: data?.updateclient?.message,
                        duration: 5
                    })
                    dispatch(updateClient(updatedClient));
                    setImage(savedFile.url);
                    dispatch(setLoader(false));
                } else {
                    message.error({
                        content: data?.updateclient?.message,
                        duration: 5
                    })
                    dispatch(setLoader(false));
                }
            } catch (error) {
                dispatch(setLoader(false));
            }
        }
    };

    useEffect(() => {
    }, [image, setImage])

    const handleDelete = async () => {
        dispatch(setLoader(true))
        const { data } = await updateclient({
            variables: {
                input: {
                    id: id,
                    image: null
                }
            },
        });
        if (data?.updateclient?.status === 200) {
            const updatedClient = {
                ...agencyData,
                image: null
            };
            dispatch(updateClient(updatedClient));
            setImage(null);

            dispatch(setLoader(false))
        }
    }

    const fileInputRef = useRef(null);
    const triggerFileInput = () => {
        fileInputRef.current.click()

    };
    return (
        <>
        {/* Record locked by another user */}
        {id && lockChecked && lockIsReadOnly && !viewReadOnly && (
            <RecordLockedModal
                visible={true}
                lockedBy={lockedBy}
                onViewReadOnly={() => setViewReadOnly(true)}
                onRequestAccess={requestAccess}
                releaseRequested={releaseRequested}
                onGoBack={() => navigation(-1)}
            />
        )}

        {/* Banner for lock holder when someone requests access */}
        {id && releaseRequestFrom && (
            <ReleaseRequestBanner
                requestFrom={releaseRequestFrom}
                onRelease={() => {
                    releaseForRequester();
                    navigation(-1);
                }}
                onDismiss={dismissReleaseRequest}
            />
        )}

        <div className="page-wrapper">
            <div className="content container-fluid bpcp">
                <style>{BPCP_STYLES}</style>
                <style>{`
         .icon-container { position: relative; display: inline-block; }
         .plus-icon { font-size: 20px; cursor: pointer; }
         .action-icons { position: absolute; top: 0; left: 0; display: flex; gap: 5px; opacity: 0; transition: opacity 0.3s ease-in-out; }
         .icon-container:hover .action-icons { opacity: 1; }
        `}</style>

                {/* Read-only banner */}
                {isReadOnly && (
                    <div style={{
                        background: "#fff7e6", border: "1px solid #ffd591", padding: "8px 16px",
                        borderRadius: 6, marginBottom: 8, display: "flex", alignItems: "center", gap: 8,
                    }}>
                        <span style={{ fontSize: 16 }}>🔒</span>
                        <span>
                            <strong>Read-Only Mode</strong> — This client is being edited by{" "}
                            <strong>{lockedBy?.userName}</strong>. You can view but not modify.
                        </span>
                    </div>
                )}

                <div className="bpcp-shell">
                    {/* ===================== LEFT IDENTITY RAIL ===================== */}
                    <aside className="bpcp-rail">
                        <div className="bpcp-rail-avatar">
                            {/* Image Section */}
                            <div className="w-120">
                                <div>
                                    {agencyData?.image ? (
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            <div className="profile-img">
                                                <img
                                                    src={S3ACCESSURL + image}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '120px',
                                                        height: '120px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#ccc',
                                                        color: '#333',
                                                        fontSize: '20px',
                                                        position: 'relative',
                                                        border: '2px solid #ddd',
                                                    }}
                                                />
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    style={{ display: 'none' }}
                                                    ref={fileInputRef}
                                                />
                                                <label
                                                    htmlFor="imageUpload"
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: '-5px',
                                                        right: '10px',
                                                        background: 'transparent',
                                                        color: '#000',
                                                        marginLeft: '-15px',
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        fontSize: '18px',
                                                    }}
                                                >
                                                    <div className="icon-container">
                                                        <Link
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                triggerFileInput();
                                                            }}
                                                            to="#"
                                                            className="plus-icon"
                                                        >
                                                            +
                                                        </Link>
                                                        <div className="action-icons">
                                                            <Link
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    triggerFileInput();
                                                                }}
                                                                to="#"
                                                            >
                                                                <i className="fa fa-pencil" />
                                                            </Link>
                                                            <Link
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleDelete();
                                                                }}
                                                                to="#"
                                                                className="delete-icon"
                                                            >
                                                                <i className="fa fa-trash" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '120px',
                                                height: '120px',
                                                borderRadius: '50%',
                                                backgroundColor: '#898484',
                                                color: 'white',
                                                fontSize: '20px',
                                                position: 'relative',
                                                border: '2px solid #898484',
                                            }}
                                        >
                                            {agencyData?.clientName ? getInitials(agencyData?.clientName) : 'N/A'}
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                            />
                                            <label
                                                htmlFor="imageUpload"
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '5px',
                                                    right: '5px',
                                                    background: 'transparent',
                                                    color: '#000',
                                                    marginLeft: '-10px',
                                                    borderRadius: '50%',
                                                    cursor: 'pointer',
                                                    fontSize: '18px',
                                                }}
                                            >
                                                <Link
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        triggerFileInput();
                                                    }}
                                                    to="#"
                                                    className="edit-icon"
                                                >
                                                    <i className="fa fa-pencil" />
                                                </Link>
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="bpcp-rail-name">{agencyData?.clientName || (id ? "Client" : "New client")}</div>
                        {agencyData?.status ? (
                            <span className={`bpcp-rail-status ${String(agencyData.status).toLowerCase() === "active" ? "on" : "off"}`}>{agencyData.status}</span>
                        ) : null}

                        <div className="bpcp-rail-stats">
                            {agencyData?.department ? (
                                <div className="bpcp-rail-stat">
                                    <div className="bpcp-rail-stat-ico"><i className="fa fa-building" /></div>
                                    <div className="bpcp-rail-stat-txt"><span>Department</span><b>{agencyData.department}</b></div>
                                </div>
                            ) : null}
                            {agencyData?.noOfSlots ? (
                                <div className="bpcp-rail-stat">
                                    <div className="bpcp-rail-stat-ico"><i className="fa fa-th-large" /></div>
                                    <div className="bpcp-rail-stat-txt"><span>Slots</span><b>{agencyData.noOfSlots}</b></div>
                                </div>
                            ) : null}
                            {agencyData?.BlueplanitReportingLead ? (
                                <div className="bpcp-rail-stat">
                                    <div className="bpcp-rail-stat-ico"><i className="fa fa-user" /></div>
                                    <div className="bpcp-rail-stat-txt"><span>Lead</span><b>{agencyData.BlueplanitReportingLead}</b></div>
                                </div>
                            ) : null}
                        </div>

                        <nav className="bpcp-rail-nav">
                            {[
                                { id: "details", label: "Details", icon: "fa fa-id-card-o" },
                                { id: "contacts", label: "Contacts", icon: "fa fa-address-book-o" },
                                { id: "slots", label: "Slots", icon: "fa fa-th-large" },
                                ...(id ? [{ id: "team", label: "Team", icon: "fa fa-users" }] : []),
                                ...(id && canSeeWhatsApp ? [{ id: "whatsapp", label: "WhatsApp", icon: "fa-brands fa-whatsapp" }] : []),
                            ].map((t) => (
                                <button
                                    key={t.id}
                                    type="button"
                                    className={`bpcp-rail-tab ${section === t.id ? "active" : ""}`}
                                    onClick={() => setSection(t.id)}
                                >
                                    <span className="bpcp-rail-tab-ico"><i className={t.icon} /></span>
                                    {t.label}
                                </button>
                            ))}
                        </nav>
                    </aside>

                    {/* ===================== RIGHT MAIN PANEL ===================== */}
                    <main className="bpcp-main">
                        <div className="bpcp-topbar">
                            <button type="button" className="bpcp2-back" onClick={() => navigation(-1)}>
                                <span className="bpcp2-back-ico">‹</span> Back
                            </button>
                            <div className="bpcp-topbar-title">
                                <span className="t1">{agencyData?.clientName || (id ? "Client" : "New Client")}</span>
                                <span className="t2">
                                    {section === "details" ? "Agency details" :
                                     section === "contacts" ? "Points of contact" :
                                     section === "slots" ? "Client slots" :
                                     section === "whatsapp" ? "WhatsApp" : "Team & history"}
                                </span>
                            </div>
                            {!isReadOnly && (
                                <button type="button" className="bpcp2-save" onClick={HandleSubmit}>
                                    {id ? "Save changes" : "Create client"}
                                </button>
                            )}
                        </div>

                        <div style={isReadOnly ? { pointerEvents: "none", opacity: 0.7 } : {}}>
                            {section === "details" && (
                            <div className="bpcp-panel bpcp-grid">
                                <div className="bpcp-panel-head">
                                    <span className="bar" />
                                    <span className="ttl">Agency Details</span>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3 mb-2" >
                                        <InputField
                                            label="Agency Name"
                                            type="text"
                                            name="clientName"
                                            value={agencyData?.clientName}
                                            error={errors.clientName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {!id && <div className="col-md-3 mb-2">
                                        <InputField
                                            label="Client Email"
                                            type="email"
                                            name="emailId"
                                            value={agencyData?.emailId}
                                            placeholder="example@gmail.com"
                                            error={errors.emailId}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>}
                                    <div className="col-md-3 mb-2">
                                        <InputField
                                            label="Address"
                                            type="text"
                                            name="physicalAddress"
                                            value={agencyData?.physicalAddress}
                                            onChange={handleChange}
                                            required
                                            error={errors.physicalAddress}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-2" >
                                        <InputField
                                            label="City"
                                            type="text"
                                            name="city"
                                            value={agencyData?.city}
                                            onChange={handleChange}
                                            required
                                            error={errors.city}
                                        />
                                    </div>

                                    <div className="col-md-2 mb-2">
                                        <InputField
                                            label="State"
                                            type="text"
                                            name="state"
                                            value={agencyData?.state}
                                            onChange={handleChange}
                                            required
                                            error={errors.state}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-2" >
                                        <InputField
                                            label="Zip"
                                            type="text"
                                            name="zip"
                                            value={agencyData?.zip}
                                            onChange={handleChange}
                                            required
                                            error={errors.zip}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-2" >
                                        <SelectInput
                                            label="Time Zone"
                                            name="timeZone"
                                            value={agencyData?.timeZone}
                                            formControl={true}
                                            error={errors.timeZone}
                                            style={{ height: '100%', minHeight: '40px', lineHeight: '40px', border: 'none' }}
                                            onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "timeZone",
                                                        value: e
                                                    }
                                                })
                                            }}
                                            options={getOptionsByPath(NestedDatabucket, [ADD_CLIENT, ADD_CLIENT_TIMEZONE])}

                                            required
                                        />
                                    </div>
                                    <div className="col-md-3 mb-2" >
                                        <InputField
                                            label="No.of Slots"
                                            type="number"
                                            name="noOfSlots"
                                            value={agencyData?.noOfSlots}
                                            onChange={handleChange}
                                            required
                                            error={errors.noOfSlots}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-2" >
                                        <SelectInput
                                            label="Departments Assigned"
                                            name="department"
                                            style={{ height: '100%', minHeight: '40px', lineHeight: '40px', border: 'none' }}
                                            value={agencyData?.department}
                                            formControl={true}
                                            error={errors.department}
                                            onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "department",
                                                        value: e
                                                    }
                                                })
                                            }}
                                            options={getOptionsByPath(NestedDatabucket, [ADD_CLIENT, ADD_CLIENT_DEPARTMENT])}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-3 mb-2" >
                                        <SelectInput
                                            label="Services Assigned"
                                            name="ServicesAssigned"
                                            style={{ height: '100%', minHeight: '40px', lineHeight: '40px', border: 'none' }}
                                            value={agencyData?.ServicesAssigned}
                                            formControl={true}
                                            error={errors.ServicesAssigned}
                                            onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "ServicesAssigned",
                                                        value: e
                                                    }
                                                })
                                            }}
                                            options={getOptionsByPath(NestedDatabucket, [CLIENT_INFO, CLIENT_SERVICESASSIGNED])}
                                            required
                                            mode="multiple"
                                        />
                                    </div>
                                    <div className="col-md-3 mb-2" >
                                        <SelectInput
                                            label="Blueplanit Reporting Lead"
                                            name="BlueplanitReportingLead"
                                            style={{ height: '100%', minHeight: '40px', lineHeight: '40px', border: 'none' }}
                                            value={agencyData?.BlueplanitReportingLead}
                                            error={errors.BlueplanitReportingLead}
                                            formControl={true}
                                            onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "BlueplanitReportingLead",
                                                        value: e
                                                    }
                                                })
                                            }}
                                            options={Employees}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-2 mb-2" >
                                        <SelectInput
                                            label="Status"
                                            name="status"
                                            style={{ height: '100%', minHeight: '40px', lineHeight: '40px', border: 'none' }}
                                            value={agencyData?.status}
                                            formControl={true}
                                            error={errors.status}
                                            onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "status",
                                                        value: e || "Active"
                                                    }
                                                })
                                            }}
                                            options={getOptionsByPath(NestedDatabucket, [ADD_CLIENT, CLIENT_STATUS])}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            )}
                            {section === "contacts" && (
                            <PointOfContact agencyData={agencyData} setAgencyData={setAgencyData} errors={errors} setErrors={setErrors} />
                            )}
                            {section === "slots" && (
                            <Slots agencyData={agencyData} setAgencyData={setAgencyData} />
                            )}
                        </div>

                        {section === "details" && clientConfidentialAccess && (
                            <div style={isReadOnly ? { pointerEvents: "none", opacity: 0.7 } : {}}>
                                <DateComponent agencyData={agencyData} setAgencyData={setAgencyData} />
                            </div>
                        )}
                        {/* Outside the read-only wrapper: messaging is governed by WhatsApp access, not client edit rights. */}
                        {id && canSeeWhatsApp && section === "whatsapp" && (
                            <div className="bpcp-panel">
                                <WhatsAppRecordTab clientId={id} recordName={agencyData?.clientName} active={section === "whatsapp"} />
                            </div>
                        )}
                        {id && section === "team" && (
                            <>
                                <div className="card tab-box">
                                    <div className="row user-tabs">
                                        <div className="col-lg-10 col-md-10 col-sm-10 line-tabs">
                                            <ul className="nav nav-tabs nav-tabs-bottom">

                                                <li className="nav-item">
                                                    <Link
                                                        to="#Employee_List"
                                                        data-bs-toggle="tab"
                                                        className={`nav-link ${activeTab === "Employee_List" ? "active" : ""}`}
                                                        onClick={() => setActiveTab("Employee_List")}
                                                    >
                                                        Employee List
                                                    </Link>
                                                </li>
                                                {clientConfidentialAccess && (
                                                    <li className="nav-item">
                                                        <Link
                                                            to="#Edit_History"
                                                            data-bs-toggle="tab"
                                                            className={`nav-link ${activeTab === "Edit_History" ? "active" : ""}`}
                                                            onClick={() => setActiveTab("Edit_History")}
                                                        >
                                                            Edit Work History
                                                        </Link>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-content">
                                    {activeTab === "Employee_List" && (
                                        <EmployeeMapIng />
                                    )}
                                    {clientConfidentialAccess && activeTab === "Edit_History" && (
                                        <EditClientHistory />
                                    )}
                                </div>
                            </>
                        )}
                    </main>
                </div>

            </div>

        </div>
        </>
    );
};

